/* eslint-disable no-param-reassign */
import axios from 'axios';
import urlData from '../config.json';

const { ZIPCODEBASE_URL } = urlData;

const request = async (params) => {
    const { url, method = 'get', data = {} } = params;

    try {
        const fullUrl = `${ZIPCODEBASE_URL}${url}`;

        const response = await axios({
            method,
            url: fullUrl,
            data,
        });

        return { error: '', data: response.data, status: '' };
    } catch (err) {
        return { error: err, data: '', status: err.response?.status };
    }
};

export default request;
